import React from 'react';
import cm from 'classnames';
import {
  ContextMenu as ReactContextMenu,
  ContextMenuTriggerProps,
  ContextMenuTrigger,
  ContextMenuProps,
  MenuItemProps,
  SubMenuProps,
  MenuItem,
  SubMenu,
} from 'react-contextmenu';
import { useHoverClose } from './_use-hover-close';

type WithChildren = { children?: React.ReactNode };
type MenuContainerProps = ContextMenuProps & WithChildren;
type MenuTriggerPropsWithChildren = ContextMenuTriggerProps & WithChildren;
type MenuItemPropsWithChildren = MenuItemProps & WithChildren;
type SubMenuPropsWithChildren = SubMenuProps & WithChildren;

interface Props extends MenuContainerProps {
  id: string;
  className?: string;
}

const MenuContainer = ReactContextMenu as React.ComponentType<MenuContainerProps>;

export const ContextMenu: React.FC<Props> = ({ className, children, id, ...rest }) => {
  const { onEnter, onLeave, onShow } = useHoverClose();

  return (
    <MenuContainer id={id} className={cm(className)} onShow={onShow} {...rest}>
      <div onMouseEnter={onEnter} onMouseLeave={onLeave}>
        {children}
      </div>
    </MenuContainer>
  );
};

export const MenuTrigger = ContextMenuTrigger as React.ComponentType<MenuTriggerPropsWithChildren>;
export const MenuOption = MenuItem as React.ComponentType<MenuItemPropsWithChildren>;
export const NestedMenu = SubMenu as React.ComponentType<SubMenuPropsWithChildren>;
